var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("el-divider", { attrs: { "content-position": "left" } }, [
        _vm._v(_vm._s(_vm.$t("basicData.PriceDetails")) + "2"),
      ]),
      _c(
        "div",
        { staticClass: "feet-r mb10" },
        [
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "permit",
                  rawName: "v-permit:remove",
                  value: "btn:payable:quoteManagement:addEdit",
                  expression: "'btn:payable:quoteManagement:addEdit'",
                  arg: "remove",
                },
              ],
              attrs: { size: "small", type: "primary" },
              on: { click: _vm.handleAdd },
            },
            [_vm._v(_vm._s(_vm.$t("basicData.AddARow")))]
          ),
          _c("importAndDownloadCmp", {
            attrs: {
              "subregion-list": _vm.subregionList,
              "fee-list": _vm.feeTypeList,
              "get-data-func": _vm.onDownloadOffer,
            },
            on: { importList: _vm.onImportList },
          }),
          _c(
            "el-popover",
            {
              attrs: { placement: "bottom-start", trigger: "hover" },
              scopedSlots: _vm._u([
                {
                  key: "reference",
                  fn: function () {
                    return [
                      _c("el-button", { attrs: { size: "small", plain: "" } }, [
                        _vm._v(_vm._s(_vm.$t("basicData.ClearTheOffer")) + " "),
                      ]),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _c(
                "div",
                { staticClass: "feet" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.clearOffers(1)
                        },
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("basicData.EmptyCurrentPartition")) + " "
                      ),
                    ]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "feet-btn",
                      attrs: { size: "small", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.clearOffers(2)
                        },
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("basicData.EmptyAllPartitions")) + " "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c("TableCmp", {
        ref: "tableRef",
        attrs: {
          "fee-list": _vm.feeTypeList,
          "table-data": _vm.currentTableData,
        },
        on: { change: _vm.handleTableChange },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }